// assets
import { IconKey, IconDeviceMobile, IconBuildingStore, IconDeviceTablet, IconUserPlus } from '@tabler/icons';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { IconCoin } from '@tabler/icons';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ArticleIcon from '@mui/icons-material/Article';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import SellIcon from '@mui/icons-material/Sell';
import HandymanIcon from '@mui/icons-material/Handyman';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { IconMessage, IconMessagePlus } from '@tabler/icons';
// constant
const icons = {
    AccountBalanceIcon,
    IconDeviceMobile,
    IconBuildingStore,
    IconDeviceTablet,
    IconUserPlus,
    ReceiptIcon,
    AssignmentReturnedIcon,
    RequestPageIcon,
    AddShoppingCartIcon,
    IconCoin,
    SummarizeIcon,
    FolderOpenIcon,
    ArticleIcon,
    AssistantDirectionIcon,
    SellIcon,
    HandymanIcon,
    IconMessage,
    IconMessagePlus
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //
function children() {
    const children = [
        // {
        //     id: 'shops',
        //     title: 'Shops',
        //     caption: 'Shops for sale',
        //     type: 'item',
        //     url: '/menu/shops',
        //     target: false,
        //     icon: icons.IconBuildingStore,
        // },
        // {
        //     id: 'customer',
        //     title: 'Customer Controller',
        //     type: 'item',
        //     url: '/menu/customer',
        //     target: false,
        //     icon: icons.IconUserPlus
        // },
        // {
        //     id: 'invoice',
        //     title: 'Invoice',
        //     type: 'item',
        //     url: '/menu/invoice',
        //     target: false,
        //     icon: icons.ReceiptIcon
        // }
    ];

    if (localStorage.getItem('role')) {
        const Roles = localStorage.getItem('role').split(',');
        if (Roles.includes('38')) {
            children.push({
                id: 'requestpreoder',
                title: 'Preorder',
                caption: 'Resquest Product',
                type: 'collapse',
                icon: icons.AddShoppingCartIcon,
                children: [
                    {
                        id: 'preorder',
                        title: 'Preorder',
                        // caption: 'Shops for sale',
                        type: 'item',
                        url: '/menu/preorder',
                        target: false,
                        icon: icons.AssignmentReturnedIcon
                    },
                    {
                        id: 'preorder-invoice',
                        title: 'Preorder Invoice',
                        type: 'item',
                        url: '/menu/preorder/invoice',
                        target: false,
                        icon: icons.RequestPageIcon
                    }
                ]
            });
            children.push({
                id: 'requestpreoderConsign',
                title: 'Consignment Stock',
                caption: `${localStorage.getItem('locationCode')}`,
                type: 'collapse',
                icon: icons.AssistantDirectionIcon,
                children: [
                    {
                        id: 'RequestmentStockLocation',
                        title: 'Requestment',
                        // caption: 'Shops for sale',
                        type: 'collapse',
                        url: '/menu/request/consignment',
                        icon: icons.AssignmentReturnedIcon,
                        children: [
                            {
                                id: 'RequestStockLocation',
                                title: 'Request stock',
                                // caption: 'Shops for sale',
                                type: 'item',
                                url: '/menu/request/consignment',
                                target: false,
                                icon: icons.AssignmentReturnedIcon
                            },
                            {
                                id: 'RequestSaleLocationStock',
                                title: 'Create Invoice',
                                // caption: 'Shops for sale',
                                type: 'item',
                                url: '/menu/request/invoice/temporary',
                                target: false,
                                icon: icons.SellIcon
                            }
                        ]
                    },
                    {
                        id: 'StockLocationTracking',
                        title: 'Tracking',
                        // caption: 'Shops for sale',
                        type: 'collapse',
                        url: '/menu/request/consignment',
                        icon: icons.AssignmentReturnedIcon,
                        children: [
                            {
                                id: 'RequestStockLocationTrackingStock',
                                title: 'Tracking Stock',
                                // caption: 'Shops for sale',
                                type: 'item',
                                url: '/menu/request/consignment/track/stock',
                                target: false,
                                icon: icons.AssignmentReturnedIcon
                            },
                            {
                                id: 'RequestStockLocationTrackingTemporaryInvoice',
                                title: 'Tracking Invoice',
                                // caption: 'Shops for sale',
                                type: 'item',
                                url: '/menu/request/consignment/track/temporaryinvoice',
                                target: false,
                                icon: icons.SellIcon
                            }
                        ]
                    }
                ]
            });
            children.push({
                id: 'changerequestmenu',
                title: 'Change Request',
                type: 'collapse',
                icon: icons.HandymanIcon,
                children: [
                    {
                        id: 'changerequest',
                        title: 'Create CR',
                        caption: 'Request to change',
                        type: 'item',
                        url: '/menu/request/changerequest',
                        target: false,
                        icon: icons.IconMessagePlus
                    },
                    {
                        id: 'changerequestlist',
                        title: 'My Request',
                        type: 'item',
                        url: '/menu/list/changerequest',
                        target: false,
                        icon: icons.IconMessage
                    }
                ]
            });
        }
        // ── Loan System (origination) ─────────────────────────────────────────
        // Taking an application is counter work, not Finance work: whoever can ring up a
        // sale should be able to start one or park a draft. Gated on 38 (shop staff) to
        // match /api/loan's ORIGINATION_ROLES — a menu wider than the API would just show
        // everyone a form that 403s on save.
        if (Roles.includes('38') || Roles.includes('65')) {
            children.push({
                id: 'loan-origination',
                title: 'ສິນເຊື່ອ / Loan',
                caption: 'Hire-purchase application',
                type: 'collapse',
                icon: icons.AccountBalanceIcon,
                children: [
                    {
                        id: 'loan-register',
                        title: 'ສະໝັກສິນເຊື່ອ',
                        caption: 'New application',
                        type: 'item',
                        url: '/menu/loan/register',
                        target: false,
                        icon: icons.RequestPageIcon
                    },
                    {
                        id: 'loan-list',
                        title: 'ໃບສະໝັກຂອງຂ້ອຍ',
                        type: 'item',
                        url: '/menu/loan/applications',
                        target: false,
                        icon: icons.ArticleIcon
                    }
                ]
            });
        }

        //stockcustomer;
        if (Roles.includes('47')) {
            children.push({
                id: 'shopsCustomer',
                title: 'Shops',
                caption: 'Customer Shop',
                type: 'collapse',
                icon: icons.IconBuildingStore,
                children: [
                    {
                        id: 'shobps',
                        title: 'Stock',
                        // caption: 'Shops for sale',
                        type: 'item',
                        url: '/stockcustomer/shops',
                        target: false,
                        icon: icons.IconBuildingStore
                    },
                    {
                        id: 'invoice',
                        title: 'Invoice',
                        type: 'item',
                        url: '/stockcustomer/invoice',
                        target: false,
                        icon: icons.ReceiptIcon
                    },
                    {
                        id: 'receipt',
                        title: 'Import',
                        type: 'item',
                        url: '/stockcustomer/receipt',
                        target: false,
                        icon: icons.AssignmentReturnedIcon
                    },
                    {
                        id: 'exchangerate',
                        title: 'Exchange Rate',
                        type: 'item',
                        url: '/stockcustomer/exchangerate',
                        target: false,
                        icon: icons.IconCoin
                    },
                    {
                        id: 'history',
                        title: 'History',
                        type: 'item',
                        url: '/stockcustomer/history',
                        target: false,
                        icon: icons.SummarizeIcon
                    },
                    {
                        id: 'report',
                        title: 'Report',
                        caption: 'Samsung Report',
                        type: 'collapse',
                        icon: icons.FolderOpenIcon,
                        children: [
                            {
                                id: 'inventory',
                                title: 'Inventory Report',
                                type: 'item',
                                url: '/stockcustomer/report/inventory',
                                target: false,
                                icon: icons.ArticleIcon
                            },
                            {
                                id: 'Sale',
                                title: 'Sale Report',
                                type: 'item',
                                url: '/stockcustomer/report/sale',
                                target: false,
                                icon: icons.ArticleIcon
                            }
                        ]
                    }
                ]
            });
        }

        // if (Roles.includes('30')) {
        //     children.push();
        // }

        // if (Roles.includes('34')) {
        //     children.push();
        // }
    }
    return children;
}
const menus = {
    id: 'menu',
    title: 'Menu',
    type: 'group',
    children: children()
};

export default menus;
